import { render } from "./UploadTypes.vue?vue&type=template&id=243bd190&ts=true"
import script from "./UploadTypes.vue?vue&type=script&lang=ts"
export * from "./UploadTypes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__